import Breadcrumb from '#client/components/common/Breadcrumb/Breadcrumb';
import { Spinner } from '@shopify/polaris';
import { useMemo } from 'react';

export default function CycleCountBreadcrumbs({ cycleCount, isLoading }) {
    const breadcrumbItems = useMemo(
        () => [
            { label: 'Cycle Counts', url: '/cycle-counts' },
            {
                label: isLoading ? <Spinner size="small" /> : cycleCount?.name || 'Untitled Cycle Count',
            },
        ],
        [cycleCount, isLoading]
    );

    return <Breadcrumb items={breadcrumbItems} />;
}
